var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{ dark: _vm.darkMode },on:{"click":function($event){return _vm.toggle()}}},[_c('div',{staticClass:"btn-theme"},[_c('i',{class:['far', _vm.darkMode ? 'fa-sun' : 'fa-moon']}),_c('i',{class:['fas', _vm.darkMode ? 'fa-moon' : 'fa-sun']})])])
}
var staticRenderFns = []

export { render, staticRenderFns }